import { Checkbox, Tooltip } from 'antd'
import { CheckboxChangeEvent } from 'antd/es/checkbox'
import { FC } from 'react'

const INCLUDED_TITLE = 'Включено в себестоимость'
const INCLUDED_DESCRIPTION =
    'При отключении создается отдельная позиция в заказе и стоимость оснастки исключается из себестоимости'

const EXCLUDED_TITLE = 'Исключено из себестоимости'
const EXCLUDED_DESCRIPTION =
    'При включении отдельная позиция заказа удаляется и стоимость оснастки включается в себестоимость'

interface ToolingCostCheckboxProps {
    included: boolean
    disabled?: boolean
    onChange: (included: boolean) => void
}

const ToolingCostCheckbox: FC<ToolingCostCheckboxProps> = ({ included, disabled, onChange }) => {
    const title = included ? INCLUDED_TITLE : EXCLUDED_TITLE
    const description = included ? INCLUDED_DESCRIPTION : EXCLUDED_DESCRIPTION

    const handleChange = (event: CheckboxChangeEvent) => {
        onChange(event.target.checked)
    }

    return (
        <Tooltip
            title={
                <span>
                    <strong>{title}</strong>
                    <br />
                    {description}
                </span>
            }
        >
            <span>
                <Checkbox checked={included} disabled={disabled} onChange={handleChange} />
            </span>
        </Tooltip>
    )
}

export default ToolingCostCheckbox
